
import './storeForm.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import zone from '../../service/zone';
import user from '../../service/user';
import store from '../../service/store';
import menuLayout from '../../directive/menu-layout';

import routing from './storeForm.routes';
import StoreFormController from './storeForm.controller';

export default angular.module('page.storeForm', [
		uirouter,
		menuLayout,
		'google.places',
		'uiSwitch',

		store,
		user,
		zone
	])
	.config(routing)
	.controller('StoreFormController', StoreFormController)
	.name;



// WEBPACK FOOTER //
// ./src/page/storeForm/index.js